import { render, staticRenderFns } from "./SmsSender.vue?vue&type=template&id=517b72cd&scoped=true"
import script from "./SmsSender.vue?vue&type=script&lang=js"
export * from "./SmsSender.vue?vue&type=script&lang=js"
import style0 from "./SmsSender.vue?vue&type=style&index=0&id=517b72cd&prod&lang=scss"
import style1 from "./SmsSender.vue?vue&type=style&index=1&id=517b72cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b72cd",
  null
  
)

export default component.exports